import { render, staticRenderFns } from "./BodyJsonEditor.vue?vue&type=template&id=91a2edb0&lang=pug"
import script from "./BodyJsonEditor.vue?vue&type=script&lang=js"
export * from "./BodyJsonEditor.vue?vue&type=script&lang=js"
import style0 from "./BodyJsonEditor.vue?vue&type=style&index=0&id=91a2edb0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports